const breakpoints = {
  values: {
    xs: 0,
    mobile_m: 375,
    mobile_l: 425,
    sm: 600,
    tablet: 768,
    md: 900,
    lg: 1200,
    xl: 1536,
  },
}

export default breakpoints
